import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { MetricsClient } from '@ecg-marktplaats/ecg-js-metrics';
import CustomGlobalConfig from './customGlobalConfig';
let metricsClient;
const getMetricsClient = () => {
  if (!metricsClient) {
    const customGlobalConfig = new CustomGlobalConfig();
    const adsenseMetricConfig = customGlobalConfig.getAdsenseMetricConfig();
    if (adsenseMetricConfig.isValidConfig) {
      const {
        gptBatchMetricsEndpointUrl,
        vurl
      } = customGlobalConfig.getAdsenseMetricConfig();
      metricsClient = new MetricsClient({
        endpointUrl: gptBatchMetricsEndpointUrl,
        virtualUrl: vurl
      });
    }
  }
  return metricsClient;
};
export const addMetrics = function () {
  var _getMetricsClient;
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return (_getMetricsClient = getMetricsClient()) === null || _getMetricsClient === void 0 ? void 0 : _getMetricsClient.addMetrics(...params);
};